import React, { useMemo } from "react";
import { useChatContext } from "../../context/chat/chat.context";
import { BodyChatComponent } from "../body-chat/body-chat.component";
import { HeaderChatComponent } from "../header-chat/header-chat.component";
import { FooterChatComponent } from "../footer-chat/footer-chat.component";

export const ChatPageBodyComponent: React.FC = () => {
  const {
    messages,
    buttons,
    enabledInput,
    handleChatSubmit,
    selectButtons,
    setEnabledInput,
  } = useChatContext();

  const renderHeaderChat = useMemo(() => {
    return (
      <>
        <HeaderChatComponent />
      </>
    );
  }, []);

  const renderBodyChat = useMemo(() => {
    return (
      <>
        <BodyChatComponent
          messages={messages}
          selectButtons={selectButtons}
          setEnabledInput={setEnabledInput}
        />
      </>
    );
  }, [messages]);

  const renderFooterChat = useMemo(() => {
    return (
      <>
        <FooterChatComponent
          buttons={buttons}
          handleChatSubmit={handleChatSubmit}
          enabledInput={enabledInput}
        />
      </>
    );
  }, [handleChatSubmit]);

  return (
    <>
      {renderHeaderChat}
      {renderBodyChat}
      {renderFooterChat}
    </>
  );
};
